<template>
  <div>
    <div class="d-flex align-center justify-space-between mb-2">
      <p class="text-grey text-body-2 font-weight-regular text-uppercase mx-2">
        {{ title }}
      </p>
      <span
        v-if="hasGoTo && canEdit"
        class="cursor-pointer text-grey text-body-2 font-weight-regular mx-2 text-decoration-underline"
        @click="emit('goTo')"
      >
        {{ t("form.edit") }}
      </span>
    </div>
    <div class="py-7 px-6 px-lg-11 rounded-xl elevation-1 d-flex flex-column ga-4 bg-background">
      <v-row
        v-for="item in items.filter(({ label, value }) => label || value)"
        :key="`${item.label}-${item.value}`"
        justify="space-between"
        no-gutters
      >
        <v-col>
          <p class="text-grey text-body-2 font-weight-regular">
            {{ item.label }}
          </p>
        </v-col>
        <v-col cols="auto">
          <p :class="{ 'd-block text-truncate': item.truncate }">
            <span class="text-body-1 font-weight-regular text-right text-wrap">{{
              item.value
            }}</span>
          </p>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, getCurrentInstance } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

defineProps<{
  title: string;
  canEdit?: boolean;
  goTo?: string;
  items: { label?: string; value?: string; truncate?: string }[];
}>();
const emit = defineEmits(["goTo"]);

const hasGoTo = computed(() => !!getCurrentInstance()?.vnode.props?.onGoTo);
</script>
